import React from 'react';
import { Link } from 'react-router-dom';
import { Clock3Icon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { companyLinks } from '../../data/navigation';
import { services } from '../../data/services';
import { site } from '../../data/site';
import { container, focusRing } from '../../utils/styles';
import { Logo } from './Logo';
import { SocialIcons } from './SocialIcons';
export function Footer() {
  const {
    t
  } = useLanguage();
  const linkClass = `rounded text-white/85 hover:text-white hover:underline ${focusRing}`;
  return <footer className="bg-brand-deeper text-white" data-id="element-101" data-mp="3n2srvycxuoil">
      <div className={`${container} grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-12`} data-id="element-102" data-mp="3n17um0z8orh1">
        <div className="md:col-span-2 lg:col-span-5" data-id="element-103" data-mp="3izw1hlh5po43">
          <Logo tone="light" data-id="element-104" data-mp="3e35nd3owx2lb" />
          <p className="mt-5 max-w-sm leading-relaxed text-white/80" data-id="element-105" data-mp="3e2ckidt2qx8g">
            {t({
            en: 'Providing compassionate, professional in-home care — helping families feel confident, supported, and at peace.',
            es: 'Brindando cuidado en el hogar compasivo y profesional — ayudando a las familias a sentirse seguras, apoyadas y en paz.'
          })}
          </p>
          <div className="mt-6" data-id="element-106" data-mp="2bdq0s6wvftxm">
            <SocialIcons data-id="element-107" data-mp="2balnmk1fhnut" />
          </div>
        </div>

        <nav className="lg:col-span-3" aria-label={t({
        en: 'Services',
        es: 'Servicios'
      })} data-id="element-108" data-mp="2gcazu30e07kh">
          <h2 className="font-display text-base font-semibold" data-id="element-109" data-mp="3425d2lomby59">{t({
            en: 'Services',
            es: 'Servicios'
          })}</h2>
          <ul className="mt-4 space-y-2.5" data-id="element-110" data-mp="381e5nn7x9pz8">
            {services.map(s => <li key={s.id} data-id="element-111" data-mp="2u3pho6ik62py">
                <Link to={`/services#${s.id}`} className={linkClass} data-id="element-112" data-mp="2u2eiyl3yzl5p">
                  {t(s.shortName)}
                </Link>
              </li>)}
          </ul>
        </nav>

        <nav className="lg:col-span-4" aria-label={t({
        en: 'Company',
        es: 'Compañía'
      })} data-id="element-113" data-mp="1imzgj1szs137">
          <h2 className="font-display text-base font-semibold" data-id="element-114" data-mp="1nnn8pqsyinz0">{t({
            en: 'Company',
            es: 'Compañía'
          })}</h2>
          <ul className="mt-4 space-y-2.5" data-id="element-115" data-mp="13jg133iax5yt">
            {companyLinks.map(l => <li key={l.path} data-id="element-116" data-mp="zk76xxjcn62q">
                <Link to={l.path} className={linkClass} data-id="element-117" data-mp="zjxn6rowdv5h">
                  {t(l.label)}
                </Link>
              </li>)}
          </ul>
        </nav>
      </div>

      <div className="border-t border-white/15" data-id="element-118" data-mp="pstc432ceufx">
        <ul className={`${container} grid gap-5 py-8 sm:grid-cols-2 lg:grid-cols-4`} data-id="element-119" data-mp="ktzxg7bbkxe6">
          <li className="flex gap-3" data-id="element-120" data-mp="fv53qabtdofa">
            <PhoneIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-121" data-mp="fu3rw3mz4xwi" />
            <div data-id="element-122" data-mp="bsrz5p8szwk3">
              <p className="text-sm text-white/70" data-id="element-123" data-mp="bucu3fz15hih">{t({
                en: 'Phone',
                es: 'Teléfono'
              })}</p>
              <a href={site.tel} className={`${linkClass} font-display text-lg font-bold text-white`} data-id="element-124" data-mp="6vieemwd092l">
                {site.phoneDisplay}
              </a>
            </div>
          </li>
          <li className="flex gap-3" data-id="element-125" data-mp="21886r072xa7v">
            <MailIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-126" data-mp="2199il6vx60qn" />
            <div className="min-w-0" data-id="element-127" data-mp="28rhgiujhzaxg">
              <p className="text-sm text-white/70" data-id="element-128" data-mp="2dr3vb8ez4z8d">{t({
                en: 'Email',
                es: 'Correo'
              })}</p>
              <a href={site.mailto} className={`${linkClass} break-all`} data-id="element-129" data-mp="2dor21z3rn2g0">
                {site.email}
              </a>
            </div>
          </li>
          <li className="flex gap-3" data-id="element-130" data-mp="2nfvil393avcy">
            <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-131" data-mp="2nizrgdxi2f9y" />
            <div data-id="element-132" data-mp="1puzftnmo80p2">
              <p className="text-sm text-white/70" data-id="element-133" data-mp="1pvhmle6ylxb8">{t({
                en: 'Address',
                es: 'Dirección'
              })}</p>
              <a href={site.mapsUrl} target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-134" data-mp="1uu2mtdm7ogzo">
                {site.address.street}, {site.address.city}, {site.address.region} {site.address.postalCode}
              </a>
            </div>
          </li>
          <li className="flex gap-3" data-id="element-135" data-mp="3b5psbby443sz">
            <Clock3Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-136" data-mp="3b8u4avhtk3u7" />
            <div data-id="element-137" data-mp="3fa5wn8s2v363">
              <p className="text-sm text-white/70" data-id="element-138" data-mp="3dqxm4u8eilbb">{t({
                en: 'Hours',
                es: 'Horarios'
              })}</p>
              <p className="font-semibold text-white" data-id="element-139" data-mp="3dsqqu3zgevgo">{t({
                en: 'Open 24 Hours',
                es: 'Abierto 24 Horas'
              })}</p>
            </div>
          </li>
        </ul>
      </div>

      <div className="border-t border-white/15" data-id="element-140" data-mp="3nqoh0x0vj2bx">
        <div className={`${container} flex flex-col gap-3 py-6 text-sm text-white/70 sm:flex-row sm:items-center sm:justify-between`} data-id="element-141" data-mp="3iqa6n8bsvgaq">
          <p data-id="element-142" data-mp="j2vp04djv7e">© 2026 {site.name} {t({
            en: 'All rights reserved.',
            es: 'Todos los derechos reservados.'
          })}</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2" data-id="element-143" data-mp="3rq5mvrk7q1hm">
            <a href="#" className={linkClass} data-id="element-144" data-mp="aaqgii6fedzw">
              {t({
              en: 'Privacy Policy',
              es: 'Política de Privacidad'
            })}
            </a>
            <a href="#" className={linkClass} data-id="element-145" data-mp="5cf9sgbfgjlw">
              {t({
              en: 'Terms of Service',
              es: 'Términos de Servicio'
            })}
            </a>
            <a href="#" className={linkClass} data-id="element-146" data-mp="j8ivfl88jjmr">
              {t({
              en: 'Accessibility',
              es: 'Accesibilidad'
            })}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}